import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PaymentCompleteComponent } from './payment-complete/payment-complete.component';
import { ContinuesLaterComponent } from './continues-later/continues-later.component';
import { ErrorComponent } from './main/components/error/error.component';

const routes: Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'error', component: ErrorComponent},
  {path: 'payment-complete', component: PaymentCompleteComponent},
  {path: 'continues-later', component: ContinuesLaterComponent},
  {path: 'home', component: HomeComponent/* , loadChildren: () => import('./home/home.module').then(m => m.HomeModule) */ /*, canActivate: [AuthGuard] */},
  {path: ':company', children: [{ path: 'home', component: HomeComponent, }]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload', useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
